export const MESSAGE_DELIVERY_ADDRESS_UPDATED = 'Updated delivery address'
export const MESSAGE_DEFAULT_UPDATED = 'Default updated'
export const MESSAGE_DELIVERY_ADDRESS_REMOVED = 'Removed delivery address'
export const MESSAGE_PAYMENT_METHOD_UPDATED = 'Payment method updated'
export const MESSAGE_PAYMENT_METHOD_REMOVED = 'Payment method removed'
export const MESSAGE_DEFAULT_PAYMENT_METHOD_UPDATED =
  'Default payment method updated'
export const MESSAGE_MOBILE_NUMBER_REMOVED = 'Mobile number has been removed'
export const MESSAGE_NAME_UPDATED = 'Name updated'
export const MESSAGE_VERIFICATION_CODE_RESENT = 'Verification code re-sent'
export const MESSAGE_EMAIL_ADDRESS_RESTORED = 'Email address restored'
